export default __webpack_public_path__ + "media/images/cross-white-09b5435d.svg";